import {
  ADD_ITEM,
  REMOVE_ITEM,
  RESTORE_CART,
  CHANGE_ITEM_DELIVERY_ZONE,
  CHANGE_ITEM_NOTE,
  REMOVE_BUSINESS_ITEMS,
  CHANGE_ITEM_ADDRESS,
} from '../actions/cart';
import { CartItem } from '../types';
import storage from '../lib/storage';

export default (state: CartItem[] = [], action: any): CartItem[] => {

  let newState = []
  if (Array.isArray(state)) {
    newState = [...state];
  } else {
    newState = (JSON.parse(JSON.stringify(state)));
  }
  switch (action.type) {
    case ADD_ITEM: {
      const exists = state.find(
        (item) =>
          item.product.id === action.payload.product.id &&
          item.variant?.id === action.payload.variant?.id,
      );

      if (exists) {
        // return exists
        newState = state.map((item) => {
          // if (
          //   item.product.id === action.payload.product.id &&
          //   item.variant?.id === action.payload.variant?.id
          // ) {
          //   const maxQty = item.variant?.quantity || item.product.totalQuantity;
          //   if (item.quantity >= maxQty) return item;
          //   return {
          //     ...item,
          //     quantity: item.quantity + 1,
          //   };
          // }

          return item;
        });
      } else {
        newState = [...state, action.payload];
      }
      break;
    }

    case REMOVE_ITEM: {
      newState = state.filter((item) => item.id !== action.payload);
      break;
    }

    case REMOVE_BUSINESS_ITEMS: {
      newState = state.filter(
        (item) => item.product.business.id.toString() !== action.payload,
      );
      break;
    }

    case RESTORE_CART: {
      newState = action.payload;
      break;
    }

    case CHANGE_ITEM_DELIVERY_ZONE: {
      console.log(action.payload.zone)
      newState = state.map((item) =>
        item.product.business.id === action.payload.business

          ? {
            ...item,
            deliveryZone: action.payload.zone,
          }
          : item,
      );
      break;
    }


    case CHANGE_ITEM_ADDRESS: {
      newState = state.map((item) =>
        item.product.business.id === action.payload.business
          ? {
            ...item,
            address: action.payload.address,
          }

          : item,
      );
      break;
    }

    case CHANGE_ITEM_NOTE: {
      newState = state.map((item) =>
        item.product.business.id === action.payload.business
          ? {
            ...item,
            note: action.payload.note,
          }
          : item,
      );
      break;
    }

    default: {
      return state;
    }
  }

  storage.storeCart(newState);
  return newState;
};
